module.exports = __webpack_public_path__ + "img/farzana-christopher-12.d1476c9c.jpg";